module.exports = __webpack_public_path__ + "img/product_105.bd0b457.webp";